import { Navigate } from "react-router";
import { useGetLogHistoryQuery } from "../../../apis/LogHistory.api";
import { PrimaryLogHistory, LogHistory } from "../../../types/models/LogHistory";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const LogHistoryScoped = () => {
    const {
        data,
    } = useGetLogHistoryQuery(PrimaryLogHistory.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/log-histories/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default LogHistoryScoped;
